import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// Import Font Awesome
import '@fortawesome/fontawesome-free/css/all.min.css';
// Import icon fixes
import './styles/IconFix.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// Import maintenance fee diagnostic utilities
// import './utils/diagnose-maintenance-fee';
// import './utils/find-db-triggers';

// Add initial default styles
document.addEventListener('DOMContentLoaded', () => {
  // Apply critical styles immediately
  const initialStyle = document.createElement('style');
  initialStyle.id = 'initial-theme-styles';
  initialStyle.innerHTML = `
    :root {
      --sidebar-active-bg-color: #0d6efd !important;
      --sidebar-active-text-color: #ffffff !important;
      --sidebar-bg-color: #ffffff !important;
      --sidebar-text-color: #212529 !important;
      --sidebar-hover-bg-color: #f8f9fa !important;
      --sidebar-hover-text-color: #0d6efd !important;
    }
  `;
  document.head.appendChild(initialStyle);
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Update any villa references in localStorage to unit for compatibility
const migrateLocalStorageKeys = () => {
  const oldToNewKeys = {
    'app_villa_id': 'app_unit_id',
    'app_villa_number': 'app_unit_number',
    'villa_count': 'unit_count',
    'villa_data': 'unit_data'
  };
  
  // Update each key if it exists
  Object.entries(oldToNewKeys).forEach(([oldKey, newKey]) => {
    const value = localStorage.getItem(oldKey);
    if (value !== null) {
      console.log(`Migrating localStorage key: ${oldKey} → ${newKey}`);
      localStorage.setItem(newKey, value);
      // Don't remove the old key for backward compatibility
    }
  });
  
  // Update any legacy "Villa" references in localStorage to "Unit"
  if (localStorage.getItem('app_dwelling_unit_name') === 'Villa') {
    console.log('Updating app_dwelling_unit_name from Villa to Unit');
    localStorage.setItem('app_dwelling_unit_name', 'Unit');
  }
  
  if (localStorage.getItem('app_dwelling_unit_type') === 'Villa') {
    console.log('Updating app_dwelling_unit_type from Villa to Unit');
    localStorage.setItem('app_dwelling_unit_type', 'Unit');
  }
  
  if (localStorage.getItem('app_dwelling_unit_prefix') === 'V-') {
    console.log('Updating app_dwelling_unit_prefix from V- to U-');
    localStorage.setItem('app_dwelling_unit_prefix', 'U-');
  }
};

// Run the migration when the app starts
migrateLocalStorageKeys();
